module.exports = __webpack_public_path__ + "img/dialog-footer_2.9e2afd3.webp";